type Properties = Readonly<{}>

/**
 * @description
 *	A neutral portrait of what the human being is about to do: a face inside
 *	an oval, framed by the accent of the integration.
 */
export default function LandingIllustration({}: Properties) {
	return (
		<svg aria-hidden="true" fill="none" height="100%" viewBox="0 0 133 168" width="100%">
			<defs>
				<clipPath id="landing-illustration-oval">
					<ellipse cx="66.5" cy="84" rx="40" ry="52" />
				</clipPath>
			</defs>
			<g clipPath="url(#landing-illustration-oval)">
				<circle cx="66.5" cy="72" fill="#d6d3d1" r="21" />
				<path d="M24 142c0-21 19-32 42.5-32S109 121 109 142z" fill="#d6d3d1" />
			</g>
			<ellipse
				cx="66.5"
				cy="84"
				opacity="0.55"
				rx="40"
				ry="52"
				stroke="var(--sanii-accent)"
				strokeDasharray="7 7"
				strokeWidth="2"
			/>
			<g stroke="var(--sanii-accent)" strokeLinecap="round" strokeWidth="3">
				<path d="M2.5 34.5v-20a12 12 0 0 1 12-12h20" />
				<path d="M98.5 2.5h20a12 12 0 0 1 12 12v20" />
				<path d="M130.5 133.5v20a12 12 0 0 1-12 12h-20" />
				<path d="M34.5 165.5h-20a12 12 0 0 1-12-12v-20" />
			</g>
		</svg>
	)
}
